import React, { FC } from "react";

import { PageLoader } from "@in/component-library";
import { useLayout } from "../../hooks/use-layout";

const Loader: FC = () => {
  const { translations } = useLayout();

  return (
    <div className="loader">
      <PageLoader aria-label={translations.loading || "Laster innhold."} />
    </div>
  );
};

export default Loader;
